import ApiService from '../api.service';

export default {
    /**
     *
     * @param {*} address_rid
     * @param {*} searchLine
     * @param {*} itemsPerPage
     * @param {*} page
     * @returns
     */
    async getLocalities({ address_rid = 1, searchLine = null, itemsPerPage = 10, page = 1 }) {
        const params = {
            address_rid,
            searchLine,
            itemsPerPage,
            currentItem: itemsPerPage * (page - 1)
        };

        const { data: response } = await ApiService.get('refs/cities', { params });
        return response.data;
    },

    async getMicrodistricts({ address_rid = null, address_parent_rid = 1, searchLine = '', itemsPerPage = 10, page = 1 }) {
        const params = {
            address_rid,
            address_parent_rid,
            searchLine,
            itemsPerPage,
            currentItem: itemsPerPage * (page - 1)
        };

        const { data: response } = await ApiService.get('refs/microareas', { params });
        return response.data;
    },

    async getStreets({ address_rid = null, address_parent_rid = 1, searchLine = '', itemsPerPage = 10, page = 1 }) {
        const params = {
            address_rid,
            address_parent_rid,
            searchLine,
            itemsPerPage,
            currentItem: itemsPerPage * (page - 1)
        };

        const { data: response } = await ApiService.get('refs/streets', { params });
        return response.data;
    },

    async getHouses({ address_rid = null, address_parent_rid = 1, searchLine = '', itemsPerPage = 10, page = 1 }) {
        const params = {
            address_rid,
            address_parent_rid,
            searchLine,
            itemsPerPage,
            currentItem: itemsPerPage * (page - 1)
        };

        const { data: response } = await ApiService.get('refs/houses', { params });
        return response.data;
    },

    async getFlats({ address_rid = null, address_parent_rid = 1, searchLine = '', itemsPerPage = 10, page = 1 }) {
        const params = {
            address_rid,
            address_parent_rid,
            searchLine,
            itemsPerPage,
            currentItem: itemsPerPage * (page - 1)
        };

        const { data: response } = await ApiService.get('refs/flats', { params });
        return response.data;
    }
};
